<template>
    <footer>
        <section content padding>
            <Row>
                <Col :xs="24" :sm="12" :md="8" :lg="8">
                    <div class="d-block plr-md mb-lg">
                        <h3 class="c-white mb-xs">-- {{ $common.config.lang === 'cn' ? $common.config.navigation[0].cnName : $common.config.navigation[0].enName }}</h3>
                        <p class="line-h-26" v-for="(item, index) in $common.config.navigation[0].children" :key="item.id" @click="onProduct(item, index)">
                            <router-link to="">{{ item.name }}</router-link>
                        </p>
                    </div>
                </Col>
                <Col :xs="24" :sm="12" :md="8" :lg="8">
                    <div class="d-block plr-md mb-lg">
                        <h3 class="c-white">-- {{ $common.config.lang === 'cn' ? $common.config.navigation[1].cnName : $common.config.navigation[1].enName }}</h3>
                        <p class="line-h-26" v-for="(item, index) in $common.config.navigation[1].children" :key="item.id" @click="onSolution(item, index)">
                            <router-link to="">{{ item.name }}</router-link>
                        </p>
                    </div>
                </Col>
                <Col :xs="24" :sm="12" :md="8" :lg="8">
                    <div class="d-block plr-md mb-md">
                        <h3 class="c-white">-- {{ $common.config.lang === 'cn' ? '联系我们' : 'Contact US' }}</h3>
                        <p class="c-white line-h-26">{{ $common.config.lang === 'cn' ? '电话：010-82827993' : 'Tel：010-82827993' }}</p>
                        <p class="c-white line-h-26">{{ $common.config.lang === 'cn' ? '邮箱：info@anysonus.com' : 'Mail：info@anysonus.com' }}</p>
                        <p class="c-white line-h-26">{{ $common.config.lang === 'cn' ? '地址：北京市海淀区安宁庄西路9号院25号楼7层3-726A' : 'Address: Room 3-726A, 7 / F, Building 25, Yard 9, Anning Zhuang West Road, Haidian District, Beijing' }}</p>
                    </div>
                </Col>
            </Row>
            <hr style="margin: 20px auto; border-color: rgba(255, 255, 255, .2);"/>
            <Row>
                <Col :xs="24" :sm="24" :md="12" :lg="12">
                    <a class="plr-sm copyright" target="_blank" href="http://beian.miit.gov.cn">Copyright © {{ $common.config.lang === 'cn' ? '京ICP备16010024号-2' : 'Beijing ICP 16010024-2' }}</a>
                </Col>
                <Col :xs="24" :sm="24" :md="12" :lg="12">
                    <p class="plr-sm c-warning">{{ $common.config.lang === 'cn' ? '推荐使用：Chrome, Firefox, Edge, Safari等浏览览器访问！' : 'Recommended: Chrome, Firefox, Edge, Safari and other browsers to access!' }}</p>
                </Col>
            </Row>
        </section>
    </footer>
</template>

<style scoped>
    .copyright{ color: #fff; }
    .copyright:hover{ text-decoration: underline; }
</style>

<script type="text/javascript">
    export default {
        data() {
            return {
            }
        },
        async created() {
        },
        methods: {
            onProduct(data, i){
                console.log('this.onProduct---------->', data, i);
                this.$router.push({
                    path: data.path,
                    query: {
                        id: data.id
                    }
                });
                this.$bus.emit('loadProduct', true);
            },
            onSolution(data, i){
                console.log('this.onSolution---------->', data, i);
                this.$router.push({
                    path: data.path,
                    query: {
                        id: data.id,
                        model: 'solution',
                    }
                });
                this.$bus.emit('loadSolution', true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue